// Shared order-status metadata for the online-orders admin screens.
// Lifecycle (OrderProduct.md §3.3): pending → confirmed → fulfilled,
// with pending → rejected | cancelled.
//
// The Kurdish labels live in shared/valueLabels.js because the audit log needs
// the same strings when it diffs an Order document.

import { STATUS_LABELS, statusLabel } from "../shared/valueLabels";

export { STATUS_LABELS, statusLabel };
export { unitLabel, currencyLabel } from "../shared/valueLabels";

// Tone maps to an `.rs-badge--*` modifier in shared/rtl-panel.css.
export const STATUS_TONE = {
    pending: "amber",
    confirmed: "blue",
    fulfilled: "green",
    rejected: "red",
    cancelled: "grey",
};

export const STATUS_ICON = {
    pending: "fa-hourglass-half",
    confirmed: "fa-check",
    fulfilled: "fa-truck",
    rejected: "fa-ban",
    cancelled: "fa-times",
};

// Options for the status dropdowns ("" = all, used by the filter only).
export const STATUS_OPTIONS = [
    { value: "pending", label: STATUS_LABELS.pending },
    { value: "confirmed", label: STATUS_LABELS.confirmed },
    { value: "fulfilled", label: STATUS_LABELS.fulfilled },
    { value: "rejected", label: STATUS_LABELS.rejected },
    { value: "cancelled", label: STATUS_LABELS.cancelled },
];

export const statusBadge = (s) => `rs-badge--${STATUS_TONE[s] || "grey"}`;
export const statusIcon = (s) => STATUS_ICON[s] || "fa-circle";

// The wasl number of the Sale an accepted order became. `saleRef` arrives
// populated ({ _id, numberofwasl }) from the list and detail endpoints, but the
// PATCH that accepts an order answers with the raw id — then the number is null
// and the caller falls back to the `sale` block of that same response.
export const saleNumber = (saleRef) =>
    saleRef && typeof saleRef === "object" && saleRef.numberofwasl !== undefined
        ? saleRef.numberofwasl
        : null;

// "0" is the invoice's own marker for "no wakil" — same as an empty field.
const cleanCode = (value) => {
    const code = String(value == null ? "" : value).trim();
    return code && code !== "0" ? code : "";
};

// The wakil code an order's wasl is billed to, "" when it is billed to none (a direct
// sale) and while the order has no wasl at all — tell those two apart with `saleRef`.
// The order carries its own copy, written when the invoice is created and re-synced on
// every invoice edit; `saleRef.numberOfWakil` covers orders invoiced before that copy
// existed.
export const wakilCode = (order) => {
    if (!order) return "";
    const stored = cleanCode(order.customer && order.customer.code);
    if (stored) return stored;
    return order.saleRef && typeof order.saleRef === "object"
        ? cleanCode(order.saleRef.numberOfWakil)
        : "";
};
